import type { Service } from '../redux/types';
import store from '../redux/store';

declare global {
  interface Window {
    getServiceData: <K extends keyof Service>(path: string, query: K[]) => Pick<Service, K>;
  }
}

const initGlobalServiceData = () => {
  if (!window.getServiceData) {
    window.getServiceData = <K extends keyof Service>(path: string, query: K[]) => {
      const state = store.getState();
      const { servicesList } = state.layout;

      const service = [...servicesList].find(s => s.path === path);

      if (!service) {
        throw new Error(`Service with path "${path}" not found`);
      }

      return query.reduce(
        (acc, key) => {
          if (key in service) {
            acc[key] = service[key];
          }
          return acc;
        },
        {} as Pick<Service, K>,
      );
    };
  }
};

export default initGlobalServiceData;
